import $ from 'jquery';
import Base from '../../../_config/base';

class Footer extends Base {
  constructor(el) {
    super(el);
    this.$el = $(el);

    // Get jQuery object
    this.footer = this.$el;

    //Obtain window element and check selected locale on page load
    this.window = this.footer[0].ownerDocument.defaultView;
  }
}

Footer.className = 'Footer';
export default Footer;



// WEBPACK FOOTER //
// ./src/materials/organisms/footer/footer.js